module.exports = __webpack_public_path__ + "static/media/icon_edit.5c089428.svg";